/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */

import { Routes, Route } from 'react-router-dom';
import useConnectionContext from '@hooks/useConnectionContext';
import { PRODUCT_NAME, merchantIDWhiteList } from '@/constants';
// import ShopifyBPImg from '@assets/bp_shopify_img.svg';
import { FullpageLoading } from '@/components';
import ApplicationLayout from '../Layout';
import Intro from './Intro';
import Feedback from './Feedback';
import Extra from './extra';
import Error from './Error';
import FulfillmentSetting from './FulfillmentSetting';

const coverStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  margin: 'initial',
};
export default function BPApplication() {
  const { store: { name } = {}, merchantId } = useConnectionContext();
  const shopifybpName = name === 'Shopify' ? `${PRODUCT_NAME.WORRY_FREE_PURCHASE} Application` : '';
  const shopifybpImg = name === 'Shopify' ? 'https://cdn.seel.com/assets/images/op/bp_shopify_img.svg' : '';
  const isShowOnTimeGDD = merchantIDWhiteList.includes(merchantId);
  if (!name) {
    return <FullpageLoading />;
  }
  return (
    <Routes>
      <Route
        index
        element={(
          <ApplicationLayout type="bp" name={shopifybpName} img={shopifybpImg} extraPart={<Extra name={name} />} coverStyle={coverStyle}>
            <Intro name={name} merchantId={merchantId} />
          </ApplicationLayout>
        )}
      />
      <Route
        path="/fulfillment"
        element={(
          <ApplicationLayout type="bp" name={shopifybpName} img={shopifybpImg} extraPart={<Extra name={name} />} coverStyle={coverStyle}>
            <FulfillmentSetting name={name} merchantId={merchantId} />
          </ApplicationLayout>
        )}
      />
      <Route path="/error" element={<Error />} />
      <Route path="/feedback" element={<Feedback isShowOnTimeGDD={isShowOnTimeGDD} />} />
    </Routes>
  );
}
